import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import FormInput from '../../components/elements/form_input';
import Button from '../../components/elements/button';
import {Mail, Eye, EyeOff } from '../../assets/icons';
import psw from '../../assets/icons/password.svg'
import logo from '../../assets/icons/logo.svg';
import '../../assets/css/doctor/login.css';

const DoctorLogin = () => {
    // const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Handle login logic
    };

    return (
        <div className="doctor-login">
            <div className="login-container">
                <div className="login-visual">
                    <img src="/doctor-login.svg" alt="Doctor Login" />
                </div>

                <div className="login-form-section">
                    <div className="form-header">
                        <img src={logo} alt="E-AquaHealth" className="logo" />
                        <h1>Doctor Login</h1>
                        <p>Welcome back! Please login to your account</p>
                    </div>

                    <form onSubmit={handleSubmit} className="login-form">
                        <FormInput
                            label="Email Address"
                            type="email"
                            value={formData.email}
                            onChange={(e) => setFormData({...formData, email: e.target.value})}
                            required
                            icon={<img src={Mail} alt="" />}
                        />

                        <div className="password-input">
                            <FormInput
                                label="Password"
                                type={showPassword ? 'text' : 'password'}
                                value={formData.password}
                                onChange={(e) => setFormData({...formData, password: e.target.value})}
                                required
                                icon={<img src={psw} alt="" />}
                            />
                            <button 
                                type="button" 
                                className="toggle-password"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <img src={EyeOff} alt="" /> : <img src={Eye} alt="" />}
                            </button>
                        </div>

                        <div className="form-options">
                            <label className="remember-me">
                                <input type="checkbox" />
                                <span>Remember me</span>
                            </label>
                            <Link to="/doctor/reset-password" className="forgot-password">
                                Forgot Password?
                            </Link>
                        </div>

                        <Button
                            text="Login"
                            type="submit"
                            variant="primary"
                            fullWidth
                        />

                        <div className="register-prompt">
                            <p>Don't have an account?</p>
                            <Link to="/vet/register">Register as an Aquatic Vet Doctor</Link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default DoctorLogin;